import { Notification } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.NOTIFICATION.path,
      name: "Notification",
      key: routesMap.NOTIFICATION.path,
      // commonRoute: false,
      private: true,
      // withAuth: true,
      // belongsToHeader: true,
      element: <Notification />,
    }
  ];
}
